import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'

import Datepicker from 'vuejs-datepicker'
import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'

import SinisterHeader from '@/components/regulation/auto/sinisterheader/sinisterheader.vue'
import SinisterSchedulingForms from './sinisterscheduling-form'
import SinisterSchedulingModel from '@/shared/models/regulation/auto/sinisterschedulingmodel'

import RegulationMixin from '@/store/module/regulation/mixin'
import RegulationAutoRepository from '@/shared/http/repositories/regulation/auto/regulationauto.js'
import RegulationAutoSchedulingRepository from '@/shared/http/repositories/regulation/auto/regulationautoscheduling'
import SchedulingContactRepository from '@/shared/http/repositories/configuration/schedulingcontact'
import SchedulingStatusRepository from '@/shared/http/repositories/configuration/schedulingstatus'
import SchedulingTypeRepository from '@/shared/http/repositories/configuration/schedulingtype'

import ExpertMixin from '@/store/module/expert/mixin.js'
import { actionTypes as RegulationActions } from '@/store/module/regulation/actions'

export default {
  name: 'SinisterScheduling',
  props: [ 'clear' ],
  mixins: [
    ActionsForm,
    ExpertMixin,
    RegulationMixin
  ],
  data () {
    return {
      data: SinisterSchedulingModel,
      form: SinisterSchedulingForms,
      regulationAutoId: null,
      en: en,
      es: es,
      ptBR: ptBR
    }
  },
  components: {
    Datepicker,
    SinisterHeader
  },
  mounted () {
    this.onLoad()
  },
  created () {
    // this.getAllSchedulingStatus()
    this.getAllSchedulingContact()
    this.getAllSchedulingType()
  },
  watch: {
    // TODO RETIRAR APÓS REFACTOR
    clear: function () {
      this.objList = []
      this.onClear()
    }
  },
  computed: {
    getAllExpert: function () {
      var result = []
      if ((this.experts) && (this.experts.count) > 0) {
        var data = this.experts.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'text': data[i].name, 'value': data[i].id })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
          }
        }
        this.form.expertID.options = result
      }
      return result
    }
  },
  methods: {
    onLoad () {
      this.objList = []
      this.onClear()
      this.getAllExpertByArea(process.env.AreaAutos)
      if (this.hasRegulation) {
        this.getByRegulationAuto(this.regulation.id)
      }
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
    },
    onSave () {
      var self = this
      loading.push()
      this.form.regulationAutoID.value = this.regulation.id
      if (Tools.ValidateForms(this.form, this.data, self)) {
        if (this.data.id && this.data.id !== '00000000-0000-0000-0000-000000000000') {
          this.SetData(this.data, true)
          RegulationAutoSchedulingRepository.Update(this.data)
            .then((response) => {
              if (response.status === 200 && response.data.code === -99) {
                toast.error(response.data.resultException.Message)
              } else {
                this.onResult(response, false, true)
                this.onLoad()
              }
            })
            .catch((err) => {
              this.onException(err)
            })
        } else {
          this.SetData(this.data, false)
          RegulationAutoSchedulingRepository.GetActiveByRegulationAuto(this.regulation.id)
            .then((response) => {
              if (response.status === 200 && response.data.code >= 0 && response.data.data) {
                toast.warning('<strong>ATENÇÃO! Já existe um Agendamento ativo!<br>Para criar um novo você precisa inativar o anterior.</strong>')
                console.log(response)
              } else {
                RegulationAutoSchedulingRepository.Create(this.data)
                  .then((response) => {
                    if (response.status === 200 && response.data.code === -99) {
                      toast.error(response.data.resultException.Message)
                    } else {
                      this.onResult(response, false, true)
                      this.onLoad()
                      // Ao cadastrar atualizar a regulação que esta no mixin
                      this[RegulationActions.GET_BY_ID](response.data.data.regulationAutoID)
                        .then((response) => {
                        })
                    }
                  })
                  .catch((err) => {
                    this.onException(err)
                  })
              }
              loading.close()
            })
            .catch((err) => {
              this.onException(err)
            })
        }
        loading.pop()
      }
    },
    onUpdate () {
      loading.push()
      RegulationAutoSchedulingRepository.Update(this.data)
        .then((response) => {
          this.onResult(response, true, true)
          this.onLoad()
        })
        .catch((err) => {
          this.onException(err)
        })
      loading.pop()
    },
    onEdit (obj) {
      this.SetData(obj, false)
    },
    getRegulationSurveyWay () {
      // TODO Remover após refactory da tela de Pesquisa
      if (this.form.regulationAutoID.value !== 'undefined') {
        RegulationAutoRepository.GetSurveyWay(this.form.regulationAutoID.value)
          .then((response) => {
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    getByRegulationAuto (regulationAutoId) {
      loading.push()
      RegulationAutoSchedulingRepository.GetByRegulationAutoPaging(regulationAutoId, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
      loading.pop()
    },
    onDelete (obj) {
      loading.push()
      RegulationAutoSchedulingRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
      loading.pop()
    },
    getAllSchedulingContact: function () {
      SchedulingContactRepository.GetAll()
        .then((response) => {
          var result = []
          var contact = response.data
          if (contact && contact.data && contact.count > 0) {
            var data = contact.data
            for (var i in data) {
              if (data[i].status) {
                result.push({ 'text': data[i].name, 'value': data[i].id })
              } else {
                result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
              }
            }
            this.form.scheduledWith.options = result
          }
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    getAllSchedulingStatus: function () {
      SchedulingStatusRepository.GetAll()
        .then((response) => {
          var result = []
          var status = response.data
          if (status && status.data && status.count > 0) {
            var data = status.data
            for (var i in data) {
              if (data[i].status) {
                result.push({ 'text': data[i].name, 'value': data[i].id })
              } else {
                result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
              }
            }
            this.form.schedulingStatus.options = result
          }
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    getAllSchedulingType: function () {
      SchedulingTypeRepository.GetAll()
        .then((response) => {
          var result = []
          var type = response.data
          if (type && type.data && type.count > 0) {
            var data = type.data
            for (var i in data) {
              if (data[i].status) {
                result.push({ 'text': data[i].name, 'value': data[i].id })
              } else {
                result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
              }
            }
            this.form.schedulingTypeID.options = result
          }
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    SetData: function (obj, isUpdate) {
      this.data = null
      this.data = SinisterSchedulingModel
      loading.pop()

      if (obj) {
        if (!obj.id) { // INSERT
          this.data.id = '00000000-0000-0000-0000-000000000000'
          this.data.expertID = this.form.expertID.value
          // this.data.schedulingStatusID = this.form.schedulingStatus.value
          this.data.schedulingContactID = this.form.scheduledWith.value
          this.data.schedulingTypeID = this.form.schedulingTypeID.value
          this.data.dateScheduling = new Date(this.form.dateScheduling.value)
          this.data.instructions = this.form.description.value
          this.data.observations = this.form.observations.value
          this.data.status = true
        } else {
          this.data.id = obj.id
          this.data.expertID = obj.expertID
          // this.data.schedulingStatusID = obj.schedulingStatusID
          this.data.schedulingContactID = obj.schedulingContactID
          this.data.schedulingTypeID = obj.schedulingTypeID
          this.data.dateScheduling = new Date(obj.dateScheduling)
          this.data.instructions = obj.instructions
          this.data.observations = obj.observations
          this.data.status = obj.status
          this.data.dateUpdate = obj.dateUpdate
          this.data.accountIDUpdate = obj.accountIDUpdate

          if (isUpdate) { // UPDATE
            this.data.expertID = this.form.expertID.value
            // this.data.schedulingStatusID = this.form.schedulingStatus.value
            this.data.schedulingContactID = this.form.scheduledWith.value
            this.data.schedulingTypeID = this.form.schedulingTypeID.value
            this.data.dateScheduling = new Date(this.form.dateScheduling.value)
            this.data.instructions = this.form.description.value
            this.data.observations = this.form.observations.value
            this.data.dateUpdate = null
          } else { // LOAD DATA
            this.form.expertID.value = this.data.expertID
            // this.form.schedulingStatus.value = this.data.schedulingStatusID
            this.form.scheduledWith.value = this.data.schedulingContactID
            this.form.schedulingTypeID.value = this.data.schedulingTypeID
            this.form.dateScheduling.value = this.data.dateScheduling
            this.form.description.value = this.data.instructions
            this.form.observations.value = this.data.observations
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/auto/scheduling/sinisterscheduling.js